import { useState, useEffect, useMemo } from 'react';
import Layout from 'components/Layout';
import NextImage from 'components/NextImage';
import SEO from 'components/Seo';
import Link from 'next/link';
import classes from './styles.module.scss';
import { Button, Heading, useDisclosure, Text } from '@chakra-ui/react';
import { IoMdShareAlt } from 'react-icons/io';
import { MdPlayCircle } from 'react-icons/md';
import { FaChevronLeft } from 'react-icons/fa';
import SKButton from 'components/UI/SKButton';
import SKModal from 'components/UI/SkModal';
import { videoData } from 'data/videoData';
import useMediaQuery from 'hooks/useMediaQuery';
import ReactPlayer from 'react-player';
import clsx from 'clsx';
import { useRouter } from 'next/router';
import { useClipboard } from '@chakra-ui/react';
import { useToast } from '@chakra-ui/react';
import { copyToClickBoard } from 'utils';

const VideosPage = () => {
  const toast = useToast();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const isTab = useMediaQuery('(max-width: 1000px)');
  const isMobile = useMediaQuery('(max-width: 768px)');

  const [modalId, setModalId] = useState(0);

  const handleBtnClick = id => {
    setModalId(id);
    onOpen();
  };

  const router = useRouter();

  const [showLength, setShowLength] = useState(8);

  useEffect(() => {
    if (isTab) {
      setShowLength(9);
    } else {
      setShowLength(8);
    }
  }, [isTab]);

  const videoImage = link => {
    if (!link) {
      return;
    }

    let regexCheck =
      /(https?:\/\/)?(((m|www)\.)?(youtube(-nocookie)?|youtube.googleapis)\.com.*(v\/|v=|vi=|vi\/|e\/|embed\/|user\/.*\/u\/\d+\/)|youtu\.be\/)([_0-9a-z-]+)/i;
    let id = link.match(regexCheck);

    let imageLink = `https://img.youtube.com/vi/${id && id[8]}/hqdefault.jpg`;

    return imageLink;
  };

  const formatDateFunc = date => {
    const formattedDate = new Date(date);
    const newDate = formattedDate.toLocaleDateString('en-us', {
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    });
    return newDate;
  };

  const shareVideo = video => {
    if (navigator.canShare) {
      navigator.share({
        url: video.link
      });
    } else {
      //functionality for desktop
      copyToClickBoard(video.link);
      toast({ title: 'Link copied' });
    }
  };

  return (
    <Layout>
      <SEO
        useTitleTemplate={false}
        url={router.pathname}
        title="Explainer videos on how to make money online - Sikka"
        description="Uncover the secrets of making money online with our detailed video tutorials. Learn proven techniques to increase your income. Start making money online today!"
      />
      <section className={clsx(classes.header, classes.mobileHeader)}>
        {isTab && (
          <Link href={'/'}>
            <FaChevronLeft />
          </Link>
        )}
        <h1>Videos</h1>
      </section>
      <section className={classes.videoGrid}>
        {videoData
          .filter((item, index) => index < showLength)
          .map((val, index) => (
            <div key={index} className={classes.card}>
              <div
                className={classes.imagePlayContainer}
                onClick={() => handleBtnClick(index)}
              >
                <NextImage
                  className={{ imageContainer: classes.image }}
                  src={videoImage(val.link)}
                  alt="Banner Image"
                  fill
                />
                <MdPlayCircle className={classes.playBtn} />
              </div>
              <div className={classes.content}>
                <Heading as={'h2'} noOfLines={1}>
                  {val.title}
                </Heading>
                <Text as={'span'}>Posted on {formatDateFunc(val.date)}</Text>
              </div>
              <div className={classes.cardFooter}>
                <SKButton
                  variant="button"
                  className={classes.playModalBtn}
                  onClick={() => handleBtnClick(index)}
                >
                  Play Video
                </SKButton>
                <Button
                  className={classes.shareBtn}
                  onClick={() => shareVideo(val)}
                >
                  <IoMdShareAlt />
                </Button>
              </div>
              <SKModal
                videoModal
                className={classes.modal}
                onClose={onClose}
                isOpen={isOpen && index === modalId}
                scrollBehavior={'inside'}
                title={val.name}
                key={index}
                size={isMobile ? 'full' : null}
                center
              >
                <div className={classes.reactPlayer}>
                  <ReactPlayer
                    className={classes.player}
                    width="100%"
                    height={isMobile ? '50vh' : '70vh'}
                    url={val.link}
                    controls={true}
                    playsinline={true}
                    playing={false}
                  />
                </div>
              </SKModal>
            </div>
          ))}
      </section>
      <section className={classes.btnSection}>
        {(showLength === 8 || showLength === 9) && (
          <SKButton
            className={classes.viewBtn}
            onClick={() => setShowLength(videoData.length)}
          >
            View More
          </SKButton>
        )}
      </section>
    </Layout>
  );
};

export default VideosPage;
